import { fieldState } from '@/app/model/store/domain/types'

export default {
  setListRefile (state: fieldState, val: boolean) {
    state.plantingOnly = val
  },
  setFieldData (state: fieldState, payload: any) {
    state.fieldData = payload
  },
  setSearchStatus (state: fieldState, status: number) {
    state.fieldSearchStatus = status
  },
  setSearchVariety (state: fieldState, variety: string) {
    state.fieldSearchVariety = variety
  },
  setSearchGrade (state: fieldState, grade: string) {
    state.fieldSearchGrade = grade
  },
  setSearchRisk (state: fieldState, risk: number) {
    state.fieldSearchRisk = risk
  },
  setSearchText (state: fieldState, text: string) {
    state.fieldSearchText = text
  },
  setFieldSortFlag (state: fieldState, flag: boolean) {
    state.fieldSortFlag = flag
  },
  setAccordionType (state: fieldState, type: string) {
    state.accordionType = type
  },
  setSortOrder (state: fieldState, flag: string) {
    state.sortOrder = flag
  },
  setSort (state: fieldState, type: string) {
    state.sort = type
  }
}
